<div>
  @if (!needsDestinationDevice) {
    <div class="step">
      <h2>
        Devices
      </h2>

      <div>
        @if (onlyFormulaTiles) {
          Formula tiles are cloned together with their formula and inputs, so no destination device is needed.
        } @else {
          The selected tiles do not use a device, so no destination device is needed.
        }
      </div>
    </div>
  } @else {
  <div
    class="step"
  >
    <h2>
      Devices
    </h2>

    <div
      class="halves"
    >

    </div>

    <div
      class="halves"
    >
      <div>
        <h4>Source</h4>

        @if (cloneSourceDevice) {
          <div class="device-description">
            <motn-pill
              [squareLetter]="'d'"
            >{{ cloneSourceDevice.ID }}</motn-pill>

            <div>
              {{cloneSourceDevice.Name}}
            </div>
          </div>
        }
      </div>

      <div>
        <h4>Destination</h4>

        @if (cloneDestinationDevice) {
          <div class="device-description">
            <motn-pill
              [squareLetter]="'d'"
            >{{ cloneDestinationDevice.ID }}</motn-pill>

            {{cloneDestinationDevice.Name}}
          </div>
        }

        @if (!cloneDestinationDevice) {
          <div class="device-description">
            &nbsp;
          </div>
        }

        <button
          class="small green"
          (click)="openCloneTilesDeviceMenu()"
        >
          Choose Device
        </button>

        @if (selectingDestinationDevice) {
          <motn-popover-select-devices
            [devices]="devices"
            [preselectedDevices]="[]"
            [multiOrSingle]="'single'"
            [overlayPositions]="overlayPositions"
            (clickedOutsideMenu$)="closeCloneTilesDeviceMenu()"
            (clickedOption$)="closeCloneTilesDeviceMenu($event)"
          ></motn-popover-select-devices>
        }
      </div>
    </div>
  </div>
  }

  <div
    class="step"
  >
    <div
      class="title"
    >
      <h2>
        Tile Names
      </h2>

      @if (!cloningActive) {
        <div class="find-and-replace">
          <div class="inputs">
            <input
              class="x-small"
              placeholder="Find text"
              [(ngModel)]="findText"
            >
            <input
              class="x-small"
              placeholder="Replace with"
              [(ngModel)]="replaceText"
            >
          </div>

          <div
            class="button x-small green"
            (click)="findAndReplace()"
          >
            <div>
              Apply to<br>Clones
            </div>
          </div>
        </div>
      }
    </div>

    @for (tile of tiles; track tile.ID) {
      <motn-bulk-clone-tile-row
        [original]="tile"
        [findAndReplace$]="findAndReplace$"
        [cloningActive$]="cloningActive$"
        (clone$)="onCloneUpdate(tile.ID, $event)"
      ></motn-bulk-clone-tile-row>
    }
  </div>

  <div
    class="step"
  >
    <h2>
      Finalize
    </h2>

    <div>
      <button
        (click)="startCloning()"
        [class.loading]="cloningActive"
      >
        <motn-spinner></motn-spinner>
        <span>
          Clone {{tiles.length}} Tile{{tiles.length === 1 ? '' : 's'}}
        </span>
      </button>

      @if (!cloningActive) {
        <button
          class="alt"
          (click)="done$.emit()"
        >
          Cancel
        </button>
      }
    </div>
  </div>
</div>
